module.exports = __webpack_public_path__ + "static/media/gift.315757c2.svg";